"use client";

import {
  useParams,
  usePathname,
  useRouter,
  useSearchParams,
} from "next/navigation";
import { getDefaultLanguage } from "./i18n";

export const useLangRouter = <TParams extends Record<string, string>>() => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const params = useParams<TParams & { lang?: string }>();
  const { lang = getDefaultLanguage() } = params;

  const push = (path: string) => {
    router.push(`/${lang}${path}`);
  };

  const replace = (path: string) => {
    router.replace(`/${lang}${path}`);
  };

  const replaceLang = (newLang: string) => {
    const currentPath = pathname.replace(`/${lang}`, `/${newLang}`);
    router.replace(currentPath);
    window.location.reload();
  };

  const prependLang = () => {
    const currentPath = pathname;
    if (!currentPath.startsWith(`/${lang}`)) {
      const queryParams = searchParams.toString();
      router.replace(
        `/${lang}${currentPath}${queryParams ? `?${queryParams}` : ""}`
      );
    }
  };

  return {
    push,
    replace,
    params,
    searchParams,
    lang,
    detectedLang: params.lang,
    replaceLang,
    prependLang,
  };
};
